import ModelService from '../base/ModelService';

class TextGenerator extends ModelService {
  constructor() {
    super('text-generator');
  }
}

export default new TextGenerator();
